import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { FETCH_SHORT_CODE, CLEAR_SHORT_CODE } from 'actions/auth';

const INITIAL_STATE = Immutable({
  loading: false,
  error: null,
  value: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${FETCH_SHORT_CODE}_LOADING`:
      return state.merge({ loading: true, value: null });
    case `${FETCH_SHORT_CODE}_ERROR`:
      return state.merge({ loading: false, error: action.payload });
    case FETCH_SHORT_CODE:
      return state.merge({
        loading: false,
        error: null,
        value: action.payload,
      });
    case CLEAR_SHORT_CODE:
      return state.merge({
        value: null,
      });
    default:
      return state;
  }
};
